import {
  SetDefaultData,
  CreateFormPostprocessorRequest,
} from '../form-postprocessors.actions'
import { getCreateFormPostprocessorState } from '../form-postprocessors.selectors'
import { Store, select } from '@ngrx/store'
import { Component, OnInit, OnDestroy } from '@angular/core'
import FormTrait from 'src/app/traits/form.trait'
import { Subscription } from 'rxjs'
import { Map } from 'immutable'

@Component({
  selector: 'app-create-form-postprocessor',
  templateUrl: './create-form-postprocessor.component.html',
  styleUrls: ['./create-form-postprocessor.component.css'],
})
export class CreateFormPostprocessorComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  private state$: Subscription
  public isLoading: boolean

  constructor(public store: Store<any>) {
    super()
  }

  ngOnInit() {
    this.store.dispatch<any>(new SetDefaultData('create'))
    this.state$ = this.store
      .pipe(select(getCreateFormPostprocessorState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
      })
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
  }

  public onSubmit(data: any): void {
    this.store.dispatch(new CreateFormPostprocessorRequest(data))
  }
}
